import { createTheme } from '@mui/material/styles'
import { maxContainerWidth } from '@/shared/constants/appConstants'

const theme = createTheme({
    breakpoints: {
        values: {
            xl: maxContainerWidth,
            lg: 1440,
            md: 1200,
            sm: 600,
            xs: 375,
        },
    },
    palette: {
        primary: {
            main: '#F55960',
        },
        secondary: {
            main: '#272727',
        },

        gray: '#CDCDCD',
        black: '#000',
        white: '#FFFFFF',

        custom: {
            yellowIcon: '#FFBE38',
            darkGray: '#606060',
            midGray: '#353535',
            lightGray: '#D3D3D3',
            black: '#000000',
            border: '#4E4D4D',
            progressBg: '#565656',
            topMenuBg: '#1F1F1F',
            channelNumber: '#6D6D6D',
            dropDownBackground: '#2E2E2E',
            greyFontColor: '#B0B0B0',
            placeholder: '#6D6D6D',
            neutralDark: '#3D3D3D',
            neutralLight: '#5d5d5d',
            errorRed: '#ff3333',
        },
    },
    typography: {
        fontFamily: 'Roboto, sans-serif',
        subtitle1: {
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '12px',
            lineHeight: '14px',
            color: '#FFFFFF',
        },
        subtitle2: {
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '14px',
            color: 'lightGray',
        },
        headline1: {
            fontSize: '48px',
            fontWeight: 'bold',
        },
        headline2: {
            fontSize: '36px',
            fontWeight: 'bold',
        },
        headline3: {
            fontSize: '24px',
            fontWeight: 'bold',
        },
        label1: {
            fontSize: '20px',
            fontWeight: 'bold',
        },
        label2: {
            fontSize: '16px',
            fontWeight: '500',
        },
        label3: {
            fontSize: '16px',
            fontWeight: 'bold',
        },
        label4: {
            fontSize: '14px',
            fontWeight: 'bold',
        },
        text1: {
            fontSize: '16px',
        },
        text2: {
            fontSize: '14px',
        },
        text3: {
            fontSize: '12px',
        },
        text4: {
            fontSize: '10px',
        },
    },
    components: {
        MuiSwitch: {
            styleOverrides: {
                root: {},
                switchBase: {
                    // Styles color when off
                    color: 'white',
                    padding: 0,
                    top: '14px',
                    left: '15px',
                    '&.Mui-checked': {
                        // Styles color when on
                        color: 'white',
                        padding: 0,
                        top: '14px',
                        left: '4px',
                    },
                    '&.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: '#F55960', // Track color when on
                        opacity: 1,
                    },
                },
                track: {
                    borderRadius: '9999px',
                    height: '17px',
                    width: '26px',
                    backgroundColor: '#4D4D4D99', // Track color when off
                    opacity: 1,
                },
                thumb: {
                    height: '12px',
                    width: '12px',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    minWidth: 'unset',
                    padding: 0,
                    '&:hover': {
                        backgroundColor: 'transparent', // change color on hover
                    },
                },
            },
        },
    },
    shape: {
        borderRadius: 3,
    },
})

export default theme
